import React from 'react'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { findPlatform } from 'config/platforms'
import { defaultTo, prop } from 'utils/fp'
import { isAbsoluteUrl } from 'utils/url'

const urlFor = compose(
  defaultTo('/'),
  prop('homeUrl'),
  defaultTo({}),
  findPlatform
)

const AppLink = ({ clientId, children }) => {
  const url = urlFor(clientId)

  return isAbsoluteUrl(url) ? (
    <a href={url}>{children}</a>
  ) : (
    <Link to={url}>{children}</Link>
  )
}

export default AppLink



// WEBPACK FOOTER //
// ./src/components/AppLink.js